import { useContext, useEffect } from "react";

import { MktgDataContext } from "@swa-ui/application";
import { useLocation } from "@swa-ui/browser";

import { ROUTES } from "./defines/routes";

export const useTravelerSelectionModalAnalytics = (isCaptionVisible) => {
  const { pathname } = useLocation();
  const { sendAdobeEventData } = useContext(MktgDataContext);

  useEffect(() => {
    if (pathname === ROUTES.vacations && isCaptionVisible) {
      const adobeAnalyticsObj = {
        event: "clickaction",
        eventinfo: {
          eventtype: "button",
        },
        page: {
          eventdescription: "modal:room + guest selection",
          pagename: "swav homepage",
          section: "marketing",
        },
      };

      sendAdobeEventData(adobeAnalyticsObj, "travelerSelectionModal");
    }
  }, [isCaptionVisible, pathname]);
};
